/*
 * Copyright (c) 2023 Supre  <https://www.supre.com.co>
 *
 * All Rights Reserved
 * This product is protected by copyright and distributed under
 * licenses restricting copying, distribution and decompilation.
 */

/**
Created by  José Nicolás Pereira 12/9/23
@author : José Nicolás Pereira <jpereira@supre.com.co>
@date : 12/9/23
@project : omnia-site
*/

export const CentralRisk = () => {
  return (
    <div>
      <p className="paragraphs">
        Declaro que la información que he suministrado es verídica y autorizo
        como titular de los datos de manera previa, expresa e informada a{" "}
        <b>Suprecredito S.A.S.</b> (de ahora en adelante “Suprecredito”). para
        recolectar, recaudar, almacenar, usar, circular, suprimir, procesar,
        compilar, tratar, actualizar y disponer de mi información crediticia,
        financiera y comercial con cualquier persona natural y/o jurídica que
        opere bases de datos de tipo nacional y/o internacional; con el fin de
        determinar mi capacidad de endeudamiento, riesgo crediticio y
        posibilidad de ser sujeto de créditos.
      </p>
      <p className="paragraphs">
        Adicionalmente doy mi consentimiento expreso e irrevocable a{" "}
        Suprecredito, a sus cesionarios, endosatarios o a quien represente sus
        derechos para:
      </p>
      <ol className="c-lista-1">
        <li className="paragraphs">
          <p className="paragraphs">
            En cuanto a los Intereses remuneratorios: Computarán: las sumas que
            Consultar, en cualquier tiempo, en las centrales de riesgo toda la
            información relevante para conocer mi desempeño como deudor, mi
            capacidad de pago o para valorar el riesgo futuro de concederme un
            crédito y/o cualquier otro servicio financiero.
          </p>
        </li>
        <li className="paragraphs">
          <p className="paragraphs">
            Reportar en las centrales de riesgo, directamente o por intermedio
            de las entidades públicas que ejercen funciones de vigilancia y
            control, datos tratados o sin tratar, referidos a:
          </p>
          <ol className="c-lista-2">
            <li className="paragraphs">
              <p className="paragraphs">
                Cumplimiento oportuno e incumplimiento, de mis obligaciones
                crediticias, deberes constitucionales y legales de contenido
                patrimonial, de tal forma que estas presenten una información
                veraz, pertinente, completa, actualizada y exacta de mi
                desempeño como deudor después de haber cruzado y procesado
                diversos datos útiles para obtener una información
                significativa.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Mis solicitudes de crédito, así como otros atinentes a mis
                relaciones comerciales, financieras y en general socioeconómicas
                que yo haya entregado o que consten en registros públicos, bases
                de datos o documentos públicos.
              </p>
            </li>
          </ol>
        </li>
        <li className="paragraphs">
          <p className="paragraphs">
            Conservar, tanto en o Suprecredito como en las centrales de riesgos,
            con las debidas actualizaciones y durante el periodo necesario
            señalado en sus reglamentos la información suministrada.
          </p>
          <h2 className="o-heading-4">Aceptaciones y Declaraciones</h2>
          <ol className="c-list-1">
            <li className="paragraphs">
              <p className="paragraphs">
                Reconozco y acepto que o Suprecredito no es responsable de los
                periodos de permanencia de tal información en los bancos de
                datos, toda vez que su obligación es la actualización de los
                reportes efectuados.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Reconozco y acepto que en caso de que, en el futuro, el
                autorizado en este documento efectúe una venta de cartera o una
                cesión a cualquier título de las obligaciones a mi cargo a favor
                de un tercero, los efectos de la presente autorización se
                extenderán a éste, en los mismos términos y condiciones.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Autorizo y acepto recibir comunicaciones de cobranza, así como
                todo tipo de mensajes correspondientes a información de procesos
                de o Suprecredito a los datos suministrados en, como son;
                teléfonos fijos, celulares, mensajes, SMS, dirección de
                residencia o correspondencia, correo electrónico.
              </p>
            </li>
            <li className="paragraphs">
              <p className="paragraphs">
                Autorizo y acepto que es de mi total responsabilidad actualizar
                la información de mis datos personales en caso de que estos
                cambien con el fin de lograr la fácil y oportuna comunicación
                con Suprecredito.
              </p>
            </li>
          </ol>
          <p className="paragraphs">
            Si desea mayor información sobre el tratamiento de sus Datos
            Personales, consulte nuestra Política de Privacidad de Datos en el siguiente
            link{": "}
            <a href="https://supre.com.co/politicas/tratamiento-de-datos">
              https://supre.com.co/politicas/
            </a>{"."}
          </p>
          <p className="paragraphs">
            En caso de tener cualquier inquietud respecto de la información acá
            presentada, así como para ejercer tus derechos respecto de los Datos
            Personales entregados, podrás contactarnos por medio de los
            siguientes canales:
          </p>
          <p className="paragraphs">
            Link:{" "}
            <a href="https://supre.com.co/contacto/">
              https://supre.com.co/contacto/
            </a>
            <br />
            Teléfono: +57 (301) 206 4520 <br />
            Correo: servicioalcliente@supre.com.co
          </p>
        </li>
      </ol>
    </div>
  );
};
